<div class="responsive-card">
  <div class="responsive-card-title mb-4" i18n>Account Details</div>
  <div class="account-details-grid">
    <div *ngFor="let detail of accountDetails; trackBy: trackByLabel" class="detail-card">
      <div class="detail-label" [style.max-width.%]="detail?.tooltip ? 75 : 50">
        <div>{{ detail.label }}</div>
        <img
          *ngIf="detail?.tooltip"
          class="detail-tooltip"
          [ngbTooltip]="detail.tooltip"
          [triggers]="'hover focus click'"
          [src]="'assets/icons/grey/CircleQuestion.svg'" />
      </div>
      <div class="detail-content">
        <div class="detail-value">{{ detail.value }}</div>
        <div *ngIf="detail.subtext" class="detail-subtext">{{ detail.subtext }}</div>
      </div>
    </div>
  </div>
  <div class="mt-4 d-flex flex-column gap-3">
    <div class="helper-text" *ngIf="useEntireBalance" i18n>
      *Amount reflects full balance as of submission date. Final amount may vary based on effective date.
    </div>
    <div class="helper-text">{{ effectiveDateAnnotation }}</div>
  </div>
</div>
